// ClientLogoComponent.tsx
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { orgPath } from '@/libs/orgPath/orgPath';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
import { customHide } from '@/libs/CustomHide/CustomHide';
import ClientMultiLogo from '@/components/ClientMultiLogo/ClientMultiLogo';

// Match props to actual data structure
interface OrgImages {
  logo1?: string | null; // Allow null
  bannerDesktop?: string | null;
  bannerMobile?: string | null;
  [key: string]: any; // Allow other properties
}
interface ClientLogoComponentProps {
  customTemplate: boolean;
  hasOrgCustomBanner: boolean;
  orgImages: OrgImages | null;
  orgId: string;
  showLogo1: boolean;
  setShowLogo1: React.Dispatch<React.SetStateAction<boolean>>;
  setTitleLineBreakClass: React.Dispatch<React.SetStateAction<boolean>>;
  lang: string | undefined;
  pathname: string;
  queryParams: string;
  peId: string | undefined;
}
const ClientLogoRendering: React.FC<ClientLogoComponentProps> = ({
  customTemplate,
  hasOrgCustomBanner,
  orgImages,
  orgId,
  showLogo1,
  setShowLogo1,
  setTitleLineBreakClass,
  lang,
  pathname,
  queryParams,
  peId
}) => {
  // Fallback images logic
  const logoFallbacks = [`${process.env.NEXT_PUBLIC_CDN_ENV}/bitpipe/logos/logo_${orgId}.gif`, 'https://www.techtarget.com/rms/images/company-logo-placeholder.svg'];
  let index = 0;
  const selectFallbackSrc = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (index >= logoFallbacks.length) return;
    let next = logoFallbacks[index];
    event.currentTarget.src = next;
    setShowLogo1(true);
    index++;
  };
  if (!customTemplate && !hasOrgCustomBanner) {
    return <div className={'client-logo-wrap'}>
        <Link onClick={() => pushGTMClickTags({
        click_element: 'Anchor',
        click_closest_class: 'client-logo-wrap',
        link_id: 'NONE',
        link_text: 'NONE',
        link_url: orgId
      })} href={orgPath({
        orgId: orgId,
        locale: lang,
        c: pathname.includes('/c/'),
        peId: peId
      }) + queryParams}>
          <div className={classNames(['image-wrapper', customHide(showLogo1)])}>
            <Image src={orgImages?.logo1 ?? '#'} alt={'client-logo'} width={50} height={50} unoptimized={true} onLoad={() => setShowLogo1(true)} onError={event => selectFallbackSrc(event)} />
          </div>
          <ClientMultiLogo orgId={orgId} page={'assetpage'} setbreakClass={(lineBreak: boolean) => setTitleLineBreakClass(lineBreak)} width={50} height={50} />
        </Link>
      </div>;
  }
  return null;
};
export default ClientLogoRendering;